import Request from './request';
import consts from "@/consts.js";
// Vuex
import store from '@/store.js'
// i18n
import i18n from '@/i18n'
// Self-made Snackbar
import snackbar from '@/plugins/snackbar'

async function fetchAllStockMaterials(data) {
    return Request('get', "api/available-stock-materials/index", Object.assign({}, data, {
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function save(data) {
    return Request('post', "api/available-stock-materials/save", data);
}

async function fetchSelectMaterials(data) {
    return Request('get', "api/available-stock-materials/get-available-stock-material-select", data)
}

async function exports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/available-stock-materials/export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
  }

  async function batchExports() {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/available-stock-materials/all-export')
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
  }

  async function manualMaterialExport(mode, stockId) {
      return await Request('get', 'api/available-stock-materials/manual-material-to-excel?mode=' + mode + '&stock_id=' + stockId)
  }

  async function imports(file, mode, stockId) {
      var data = new FormData();
      data.append("excel", file);
      data.append("mode", mode);
      data.append("stock_id", stockId);
      return Request('post', "api/available-stock-materials/manual-material-import", data);
  }

export default {
    fetchAllStockMaterials,
    save,
    fetchSelectMaterials,
    exports,
    batchExports,
    manualMaterialExport,
    imports,
};